import React, { forwardRef } from "react"
import type { LucideProps } from "lucide-react"

export const ChartColumnBigIconActive = forwardRef<SVGSVGElement, LucideProps>(
  (
    {
      size = 24,
      color = "currentColor",
      strokeWidth = 1.8,
      className,
      ...props
    },
    ref,
  ) => {
    return (
      <svg
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
        {...props}
      >
        <path
          key="chart-axis"
          d="M3 3V21H21"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          key="bar-1-fill"
          d="M10 10H8C7.447 10 7 10.447 7 11V16C7 16.553 7.447 17 8 17H10C10.553 17 11 16.553 11 16V11C11 10.447 10.553 10 10 10Z"
          fill="currentColor"
        />
        <path
          key="bar-2-fill"
          d="M18 5H16C15.447 5 15 5.447 15 6V16C15 16.553 15.447 17 16 17H18C18.553 17 19 16.553 19 16V6C19 5.447 18.553 5 18 5Z"
          fill="currentColor"
        />
        <path
          key="bar-1-stroke"
          d="M10 10H8C7.447 10 7 10.447 7 11V16C7 16.553 7.447 17 8 17H10C10.553 17 11 16.553 11 16V11C11 10.447 10.553 10 10 10Z"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          key="bar-2-stroke"
          d="M18 5H16C15.447 5 15 5.447 15 6V16C15 16.553 15.447 17 16 17H18C18.553 17 19 16.553 19 16V6C19 5.447 18.553 5 18 5Z"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  },
)

ChartColumnBigIconActive.displayName = "ChartColumnBigIconActive"
